import { Route, Routes } from 'react-router-dom'
import SchedulingTabs, { tabConfig } from './Tabs'
import { BasePathProvider } from 'components/Providers'
import { Box, Paper } from '@mui/material'
import PageHeader from 'components/AppBar/PageHeader'
import RedirectToFirstPermitted from 'components/RedirectToPermittedTab'
import NotFound from 'components/NotFound'
import Protected from 'components/Protected'
import StaffIndex from './Employees'
import LookUpIndex from './LookUp'

export default function PeopleIndex() {
  const basePath = '/people'

  return (
    <BasePathProvider value={`${basePath}/`}>
      <Box sx={{ pb: 2 }}>
        <PageHeader title={'People'} />
      </Box>
      <Paper sx={{ minHeight: '500px', p: 2, mb: 2 }}>
        <SchedulingTabs />
        <Routes>
          <Route path="/">
            <Route index element={<RedirectToFirstPermitted basePath={basePath} items={tabConfig} />} />
            <Route path="/staff/*" element={<Protected permission="people.employee"><StaffIndex /></Protected>} />
            <Route path="/staff/:personId/*" element={<Protected permission="people.employee"><StaffIndex /></Protected>} />
            <Route path="/look-up/*" element={<Protected permission="people.people"><LookUpIndex /></Protected>} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Paper>
    </BasePathProvider>
  )
}
